import React, { useState, useRef, useCallback, useEffect } from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from 'ckeditor5-custom-build';
import propTypes from 'prop-types';
import editorConfig from './editorConfig';
import uploadAdapterPlugin from './uploadAdapter';

const SAVE_DELAY = 1000;

const statusStyles = {
  saved: { color: '#28a745' },
  saving: { color: '#f0ad4e' },
};

const RichTextEditor = (props) => {
  const [wordCount, setWordCount] = useState({ words: 0, characters: 0 });
  const [saveStatus, setSaveStatus] = useState('saved');
  const timerRef = useRef(null);

  const handleChange = useCallback((event, editor) => {
    const data = editor.getData();

    if (props.handleChange) {
      props.handleChange(data);
    }

    setSaveStatus('saving');
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    timerRef.current = setTimeout(() => {
      setSaveStatus('saved');
    }, SAVE_DELAY);
  }, [props.handleChange]);

  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  return (
    <div>
      <CKEditor
        editor={ClassicEditor}
        config={{
          ...editorConfig,
          extraPlugins: [uploadAdapterPlugin],
        }}
        data={props.value || ''}
        onReady={(editor) => {
          const wordCountPlugin = editor.plugins.get('WordCount');
          setWordCount({
            words: wordCountPlugin.words,
            characters: wordCountPlugin.characters,
          });
          wordCountPlugin.on('update', (evt, stats) => {
            setWordCount({ words: stats.words, characters: stats.characters });
          });
        }}
        onChange={handleChange}
      />
      <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 8px', fontSize: '12px', color: '#888' }}>
        <span style={saveStatus === 'saving' ? statusStyles.saving : statusStyles.saved}>
          {saveStatus === 'saving' ? 'Saving...' : 'Saved'}
        </span>
        <div style={{ display: 'flex', gap: '12px' }}>
          <span>Words: {wordCount.words}</span>
          <span>Characters: {wordCount.characters}</span>
        </div>
      </div>
    </div>
  );
};

RichTextEditor.propTypes = {
  value: propTypes.string,
  handleChange: propTypes.func,
};

export default RichTextEditor;
